module.exports = __webpack_public_path__ + "static/logo30YearsExsisFit-5b533a19cd7906f91af7b6838ed5a091.png";